export const blockIconsCommunicationContactPhone = (
	<span className='material-symbols-outlined'>contact_phone</span>
);
